import { debounce } from "lodash"
import { store } from "../../../store/store";
import { assignCustomItemToMedicineData } from "./OMSCartUtils";
import { updateCartsItemsListToRedux, updateCartImagesListToRedux } from "../redux/commonRedux";

import { MedicineDataVersion } from "../../constants/AppConstants";

import AppTheme from "../../../AppTheme";

let cartItems: any = [];
let cartImages: any = []

store.subscribe(() => cartAndPrecriptionSubscription())

const updateCartAndPrecriptionData = () => {
    const reduxState: any = store.getState();
    if (typeof (reduxState.cartItemsData) == "object")
        cartItems = reduxState.cartItemsData ?? []
    else if (reduxState.cartItemsData?.length) {
        cartItems = JSON.parse(reduxState.cartItemsData) ?? [];
    }
    if (reduxState.cartImagesData) {
        if (typeof (reduxState.cartImagesData) == "object")
            cartImages = reduxState.cartImagesData ?? []
        else cartImages = JSON.parse(reduxState.cartImagesData) ?? [];
    }
}

const cartAndPrecriptionSubscription = debounce(updateCartAndPrecriptionData, AppTheme.upsertCartItemDebounce)

const updateDealInCart = (item) => {
    let haveCartIndex = cartItems.findIndex((cartItem) =>
        cartItem['dealId'] == item['dealId'])
    if (haveCartIndex !== -1) cartItems[haveCartIndex] = item;
    else {
        let lastMedsIndex = 0
        cartItems.forEach((cartItem) => {
            if (!cartItem['dealId'])
                lastMedsIndex = lastMedsIndex + 1
            else return
        })
        cartItems.splice(lastMedsIndex, 0, item)
    }
}

const updateMedInCart = (type, item) => {
    let haveCartIndex = cartItems.findIndex((cartItem) =>
        cartItem[type] == item[type])
    if (haveCartIndex !== -1) cartItems[haveCartIndex] = item;
    else cartItems.unshift(item);
}

const removeItemFromCart = (type, item) => {
    let itemIndex = cartItems.findIndex((cartItem) =>
        cartItem[type] == item[type]);
    if (itemIndex !== -1) cartItems.splice(itemIndex, 1)
}

export function upsertCartItemToRedux(item, quantity: any = 0, deleteItem = false) {
    if (isNaN(quantity)) quantity = 0
    if (deleteItem) {
        if (item.hasOwnProperty('dealId') && item['dealId'])
            removeItemFromCart('dealId', item)
        else if (item.hasOwnProperty('mmid') && item['mmid'])
            removeItemFromCart('mmid', item)
        else if (item.hasOwnProperty('name'))
            removeItemFromCart('name', item)
    } else {
        if (item.hasOwnProperty('dealId') && item['dealId']) {
            item['quantity'] = parseInt(quantity);
            updateDealInCart(item)
        } else if (item.hasOwnProperty('mmid') && item['mmid']) {
            item['quantity'] = parseInt(quantity);
            item['medicineDataVersion'] = MedicineDataVersion;
            updateMedInCart('mmid', item)
        } else {
            assignCustomItemToMedicineData(item, { assignmmid: false })
            item['quantity'] = parseInt(quantity);
            updateMedInCart('name', item)
        }
    }
    cartItemSubscription(cartItems);
}


export const updateCartItemsToRedux = (itemsList) => {
    updateCartsItemsListToRedux(itemsList)
}


const cartItemSubscription = debounce(updateCartItemsToRedux, AppTheme.upsertCartItemDebounce)

export const upsertCartImagesToRedux = (imageData) => {
    if (cartImages) cartImages.push(imageData)
    updateCartImagesListToRedux(cartImages)
}

export const updateCartImagesToRedux = (imageList) => {
    updateCartImagesListToRedux(imageList)
}

export function getCartTotalItemCount() {
    let itemCount = (cartItems?.length ?? 0) +
        (cartImages?.length ?? 0);
    if (itemCount) return itemCount;
    else return 0;
}
